var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"ml-2 my-1",attrs:{"color":"primary","outlined":""}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.icone))]),_c(_setup.SInfoMontant,{attrs:{"montant":_vm.ligne.montant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }